import { ArticleType, ArticleResolution, Category } from '@wix/answers-api';
import { Box } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { DATA_HOOKS } from '../../../../dataHooks';
import { ArticleSearchResultDocumentType } from '../../../../types';
import { CategoryTag } from './CategoryTag';
import { CommentsAndWatch } from './CommentsAndWatch';
import { ETATag } from './ETATag';
import { ReadingTime } from './ReadingTime';
import { StatusTag } from './StatusTag';

type TagsProps = {
  type?: ArticleType;
  resolution?: ArticleResolution;
  resolutionEta?: number | null;
  rootTopic?: Category;
  onCategoryClick: (category: Category) => void;
  readingTimeInMinutes?: number;
  isMobileView: boolean;
  docType: ArticleSearchResultDocumentType;
  views?: number;
  replies?: number;
};

export const Tags: FunctionComponent<TagsProps> = ({
  type,
  resolution,
  resolutionEta,
  onCategoryClick,
  rootTopic,
  readingTimeInMinutes,
  isMobileView,
  docType,
  views,
  replies,
}) => {
  const showStatusTag =
    type === ArticleType.FEATURE_REQUEST ||
    type === ArticleType.KNOWN_ISSUE ||
    docType === ArticleSearchResultDocumentType.WIX_FORUM_TOPIC;

  return (
  <Box
    dataHook={DATA_HOOKS.SEARCH_RESULT_ITEM_BADGES}
    marginTop="SP2"
    gap={'9px'}
    justifyItems="center"
    flexWrap="wrap"
  >
    {showStatusTag && (
      <StatusTag
        status={resolution}
        type={type}
        resolutionEta={resolutionEta}
        docType={docType}
      />
    )}
    {type === ArticleType.FEATURE_REQUEST &&
      resolutionEta &&
      resolution &&
      [ArticleResolution.PLANNED, ArticleResolution.IN_DEVELOPMENT].includes(
        resolution
      ) && <ETATag eta={resolutionEta} />}
    {(type === ArticleType.ARTICLE || type === ArticleType.FEATURE_REQUEST) &&
      rootTopic && (
        <CategoryTag onClick={onCategoryClick} category={rootTopic} />
      )}
    {docType ===
      ArticleSearchResultDocumentType.WIX_FORUM_TOPIC && (
      <CommentsAndWatch watchCount={views} commentsCount={replies} />
    )}
    {readingTimeInMinutes &&
      isMobileView &&
      type !== ArticleType.FEATURE_REQUEST &&
      type !== ArticleType.KNOWN_ISSUE && (
        <ReadingTime readingTimeInMinutes={readingTimeInMinutes} />
      )}
  </Box>
  );
};
